var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"plan-upgrade-after__value"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"plan-upgrade-after__caption"},[_vm._v(_vm._s(_vm.$tc(_vm.type,_vm.value,{value: _vm.value})))])])}
var staticRenderFns = []

export { render, staticRenderFns }